import { c as _c } from "react/compiler-runtime";
import { useIntl } from '@onefootprint/hooks';
import type { EntityOnboarding } from '@onefootprint/request-types/dashboard';
import useOnboardingKindText from '@/hooks/use-onboarding-kind-text';
import { onboardingHasPlaybook } from '../onboardings-shared/utils';
const useOnboardingLabel = () => {
  const $ = _c(3);
  const {
    formatDateWithTime
  } = useIntl();
  const onboardingKindT = useOnboardingKindText();
  let t0;
  if ($[0] !== formatDateWithTime || $[1] !== onboardingKindT) {
    t0 = onboarding => {
      const name = onboardingHasPlaybook(onboarding) && onboarding.playbook ? onboarding.playbook.name : onboardingKindT(onboarding.kind);
      return `${name} · ${formatDateWithTime(new Date(onboarding.timestamp))}`;
    };
    $[0] = formatDateWithTime;
    $[1] = onboardingKindT;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default useOnboardingLabel;